/**
 * Возвращает объект со ссылкой `postRendered`, которая переключается в фоновом режиме.
 * Если ФТ включен, ссылка `postRendered` устанавливается в `true` в фоновом режиме.
 *
 * @return {object} Объект со ссылкой `postRendered`.
 */
export const usePostRender = () => {
  const { $gaApp } = useNuxtApp()

  // $gaApp.features.get('productCardPostRenderElements'),
  const hasFeature = false

  const postRendered = ref(!unref(hasFeature))

  if (unref(hasFeature)) {
    $gaApp.services.app.scheduler.postTask(() => {
      postRendered.value = true
    }, 'background')
  }

  return {
    postRendered,
  }
}
